import { api } from './api';
import type {
  CreatePlanRequest,
  Plan,
  UpdatePlanRequest,
} from '../types/plan';

class PlanService {
  async getAll(): Promise<Plan[]> {
    const response = await api.get<Plan[]>('/plans');
    return response.data;
  }

  async getById(id: string): Promise<Plan> {
    const response = await api.get<Plan>(`/plans/${id}`);
    return response.data;
  }

  async getByCode(code: string): Promise<Plan> {
    const response = await api.get<Plan>(`/plans/code/${encodeURIComponent(code)}`);
    return response.data;
  }

  async create(payload: CreatePlanRequest): Promise<Plan> {
    const response = await api.post<Plan>('/plans', payload);
    return response.data;
  }

  async update(id: string, payload: UpdatePlanRequest): Promise<Plan> {
    const response = await api.put<Plan>(`/plans/${id}`, payload);
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/plans/${id}`);
  }
}

export const planService = new PlanService();
